export enum Region {
  EUROPE = 'EUROPE',
  USA = 'USA',
}
